export const MaterialTypeInputs = [
  { name: 'name', label: "Name", type: 'text', defaultValue: '', validation: { required: "Please enter a name" } },
  { name: 'description', label: "Description", type: 'text', defaultValue: ''},
];